/**
 * searchParams.ts — ciljano čiščenje deep-link parametrov (T1377)
 * ================================================================
 *
 * `setSearchParams({}, { replace: true })` je videti kot »počisti za sabo«, v
 * resnici pa počisti **za vsemi**: pobriše cel query niz, tudi parametre, ki
 * jih bere kdo drug na isti strani. V `BoQEditorPage` sta bila taka dva učinka
 * (`?section=…&item=…&tab=…` in `?ifcWizard=…&step=…`), v glavi iste strani pa
 * `ProjectMembersPopover` bere `?members=external` (T1337 c). Kdo od njiju
 * preživi, je odvisno od vrstnega reda učinkov — okvara, ki je videti kot
 * naključje.
 *
 * T1337 (c) je pravilni vzorec že uveljavil (`next.delete('members')`); ta
 * modul ga postavi na eno mesto, da ga ni treba prepisovati ob vsakem novem
 * deep-linku.
 */

/**
 * Kopija *prev* brez naštetih ključev.
 *
 * Vhod ostane nedotaknjen (React stanje se ne mutira), odstranijo pa se **vse**
 * ponovitve ključa — `URLSearchParams` jih dovoljuje več, `get()` pa vrne le
 * prvo, zato bi delno brisanje pustilo parameter navidez živ.
 */
export function dropSearchParams(
  prev: URLSearchParams,
  keys: readonly string[],
): URLSearchParams {
  const next = new URLSearchParams(prev);
  for (const key of keys) next.delete(key);
  return next;
}
